/**
 * Validate if email is in valid format
 * @param {string} email Email to validate
 */
function validateEmail(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}
/**
 * Validate username
 * @param {string} email User's email
 */
export function isEmailValid(email) {
  if (!email || email.length == 0 || !validateEmail(email)) {
    return false;
  }
  return true;
}

/**
 * Validate password
 * @param {string} password User password
 */
export function isPasswordValid(password) {
  if (!password || password.length == 0) {
    return false;
  }
  return true;
}

/**
 * Validate empty fields
 * @param {string} field Field to validate
 */
export function isEmpty(field) {
  if (field.length == 0) {
    return true;
  }
  return false;
}

/**
 * Shared password policy constants.
 * Policy: min 9 chars, 1 uppercase, 1 digit, 1 special character.
 * Import these in any form that creates or changes passwords.
 */
export const PASSWORD_REGEX = /^(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{9,}$/;

export const PASSWORD_RULES = {
  required: true,
  regex: PASSWORD_REGEX,
  min: 9,
};

export const PASSWORD_ERROR_MSG =
  'Password must be at least 9 characters and include one uppercase letter, one number, and one special character.';
